import { IRailway, IRailwayDirection } from '../../types/geo';
import { MAX_SUGGESTIONS } from '../../interfaces/villages';
import { ICommuteSuggest } from '../commute_popup';
import { Action, ActionTypes } from './actions';

export interface IRailwaySuggest extends IRailway, ICommuteSuggest {}

export interface IStationModel extends IRailway {
  distanceGroup?: number;
}

export interface IStations {
  currentStations: IStationModel[];
  directions: IRailwayDirection[];
  isPopupOpened?: boolean;
  regionHasStations: boolean;
  regions: number[];
  stationDistance: number;
  selectedDirection: number;
  selectedStations: number[];
  suggests?: IRailwaySuggest[];
}

export function stationsReducer(state: IStations, action: Action): IStations {
  switch (action.type) {
    case ActionTypes.DirectionChanged:
      return {
        ...state,
        selectedDirection: action.value,
      };
    case ActionTypes.Fetched:
      return {
        ...state,
        currentStations: action.value.results ?? [],
        directions: action.value.directions ?? [],
      };
    case ActionTypes.PopupDistanceChanged:
      return {
        ...state,
        stationDistance: action.value,
      };
    case ActionTypes.SelectedChanged:
      return {
        ...state,
        selectedStations: action.value,
      };
    case ActionTypes.StationsFiltered:
      return {
        ...state,
        suggests: action.stations.slice(0, MAX_SUGGESTIONS),
      };
    default:
      return state || { enabled: false, regions: [] };
  }
}
